import { useHistory } from 'react-router-dom';

/* 
  temporary hook for navigation mimicking `useNavigate` from `react-router-dom`
  which is not available in the current version, but required for properly mocking navigation in jest
*/
export const useNavigate = () => {
  let history = useHistory();
  const navigate = path => {
    if (typeof path === 'number') {
      history.go(path);
    } else {
      history.push(path);
    }
  };
  return {
    navigate
  };
};